import React, { useState, useEffect, useRef } from 'react';
import NavBar, { loadNav } from '../../visualComponents/NavBarDev';
import { useNavigate } from 'react-router-dom';
import Loader from '../../visualComponents/Loader.js';

let isLoading = false;

const ImpostazioniDev = () => {
    const [avvisoPreScadenza, setAvvisoPreScadenza] = useState(0);
    const [giorniCuscinetto, setGiorniCuscinetto] = useState(0);
    const [durataTrial, setDurataTrial] = useState(0);
    const [originalData, setOriginalData] = useState([]);
    const navigate = useNavigate();
    const inputRefs = useRef([]);

    useEffect(() => {
        loadNav();
        loadParametri();
    }, []);

    const checkParametri = () => {
        const avvisoPreScadenzaInput = document.getElementById("avvisoPreScadenza");
        const giorniCuscinettoInput = document.getElementById("giorniCuscinetto");
        const durataTrialInput = document.getElementById("durataTrial");

        if (giorniCuscinetto !== originalData[0].GiorniCuscinetto) {
            giorniCuscinettoInput.classList.add("border-red-500");
        }
        else {
            giorniCuscinettoInput.classList.remove("border-red-500");
        }

        if (avvisoPreScadenza !== originalData[0].AvvisoPreScadenza) {
            avvisoPreScadenzaInput.classList.add("border-red-500");
        } else {
            avvisoPreScadenzaInput.classList.remove("border-red-500");
        }

        if (durataTrial !== originalData[0].DurataTrialMesi) {
            durataTrialInput.classList.add("border-red-500");
        } else {
            durataTrialInput.classList.remove("border-red-500");
        }
    };

    const loadParametri = async () => {
        isLoading = true;
        const response = await fetch("/getParametri", {
            method: "GET",
            headers: { "Content-Type": "application/json" },
        });

        const data = await response.json();

        if (response.status === 500) {
            alert(data["error"]);
            console.log(data["error"]);
            navigate("/dashDev");
        }
        else {
            isLoading = false;
            setOriginalData(data);
            setAvvisoPreScadenza(data[0].AvvisoPreScadenza);
            setGiorniCuscinetto(data[0].GiorniCuscinetto);
            setDurataTrial(data[0].DurataTrialMesi);
        }
    };

    const handleConferma = async () => {
        if (avvisoPreScadenza < 0 || giorniCuscinetto < 0) {
            alert("I parametri non possono essere negativi!");
            return;
        }
        isLoading = true;
        const response = await fetch("/aggiornaParametri", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ AvvisoPreScadenza: avvisoPreScadenza, GiorniCuscinetto: giorniCuscinetto, DurataTrialMesi: durataTrial }),
        });

        if (response.status === 200) {
            isLoading = false;
            window.location.reload();
        }
        else {
            const data = await response.json();
            alert(data.message);
            console.log(data);
            window.location.reload();
        }
    };

    const handleAnnulla = () => {
        setAvvisoPreScadenza(originalData[0].AvvisoPreScadenza);
        setGiorniCuscinetto(originalData[0].GiorniCuscinetto);
        setDurataTrial(originalData[0].DurataTrialMesi);
        document.getElementById("avvisoPreScadenza").classList.remove("border-red-500");
        document.getElementById("giorniCuscinetto").classList.remove("border-red-500");
        document.getElementById("durataTrial").classList.remove("border-red-500");
    };

    const handleKeyDown = (e, index) => {
        if (e.key === "Enter") {
            e.preventDefault(); // Evita il comportamento predefinito del form
            const nextInput = inputRefs.current[index + 1];
            if (nextInput) {
                nextInput.focus(); // Passa al campo successivo
            }
        }
    };

    return (
        <div className="min-h-screen bg-white dark:bg-gray-800">
            <NavBar page={"IMPOSTAZIONI"} />
            {isLoading && <Loader />}
            <div className="flex justify-center min-h-screen p-4">
                <div className='w-full max-w-lg text-center text-black dark:text-white mt-14'>
                    <div className="grid grid-cols-2 justify-self-center mx-5 mb-2">
                        <p className="">Avviso pre-scadenza: </p>
                        <input
                            id="avvisoPreScadenza"
                            type="number"
                            className="rounded bg-white dark:bg-gray-800 border-2 border-gray-300 dark:border-gray-600 px-1 text-center"
                            value={avvisoPreScadenza}
                            onChange={(e) => setAvvisoPreScadenza(parseInt(e.target.value, 10))}
                            onBlur={checkParametri}
                            placeholder=""
                            onKeyDown={(e) => handleKeyDown(e, 0)}
                            ref={(el) => (inputRefs.current[0] = el)}
                        />
                    </div>
                    <div className="grid grid-cols-2 justify-self-center mx-5 mb-2">
                        <p className="">Giorni cuscinetto: </p>
                        <input
                            id="giorniCuscinetto"
                            type="number"
                            className="rounded bg-white dark:bg-gray-800 border-2 border-gray-300 dark:border-gray-600 px-1 text-center"
                            value={giorniCuscinetto}
                            onChange={(e) => setGiorniCuscinetto(parseInt(e.target.value, 10))}
                            onBlur={checkParametri}
                            placeholder=""
                            onKeyDown={(e) => handleKeyDown(e, 1)}
                            ref={(el) => (inputRefs.current[1] = el)}
                        />
                    </div>
                    <div className="grid grid-cols-2 justify-self-center mx-5 mb-2">
                        <p className="">Durata trial (mesi): </p>
                        <input
                            id="durataTrial"
                            type="number"
                            className="rounded bg-white dark:bg-gray-800 border-2 border-gray-300 dark:border-gray-600 px-1 text-center"
                            value={durataTrial}
                            onChange={(e) => setDurataTrial(parseInt(e.target.value, 10))}
                            onBlur={checkParametri}
                            placeholder=""
                            onKeyDown={(e) => handleKeyDown(e, 2)}
                            ref={(el) => (inputRefs.current[2] = el)}
                        />
                    </div>
                    <div className='mt-3 justify-self-center'>
                        <button
                            onClick={handleAnnulla}
                            className="ml-1 rounded py-2 px-4 bg-red-500 hover:bg-red-700 text-white font-bold"
                        >
                            Annulla
                        </button>
                        <button
                            onClick={handleConferma}
                            className="ml-1 rounded py-2 px-4 bg-green-500 hover:bg-green-700 text-white font-bold"
                        >
                            Conferma
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ImpostazioniDev;